import React from 'react'

import { EVENT_ORIGIN, TRACKING_SOURCE } from '@hozana/tracking/constants'

import { Block } from 'elements/layout/Block'

import { CommunitiesPropositions } from 'modules/community/components/CommunitiesPropositions'
import { CommunityPageSubTitle } from 'modules/community/components/CommunityPageSubTitle'

export type TCommunitiesPropositionsBlockProps = {
  communities: number[]
}

export const CommunitiesPropositionsBlock: TFC<TCommunitiesPropositionsBlockProps> = ({ communities }) =>
  communities && communities.length !== 0 ? (
    <Block
      as="aside"
      square
      noOverflow
      maxW={{ xs: 'initial', md: '712px', lg: 'initial' }}
      m={{ xs: '1em auto 0', md: '1em auto', lg: '1em 0' }}
      p={{ xs: '10px 0 10px 10px', md: '10px' }} // special padding due of slider
    >
      <CommunityPageSubTitle m="0 5px 1em">trans:community:community.join-others</CommunityPageSubTitle>
      <CommunitiesPropositions
        communities={communities}
        trackingSource={TRACKING_SOURCE.COMMUNITY_PAGE_SEE_ALSO}
        eventOrigin={EVENT_ORIGIN.COMMUNITY_RELATED_COMMUNITIES}
      />
    </Block>
  ) : null
